
const CollectionInput = Backbone.View.extend({

  tagName: 'div',
	className: 'form-group collection-input',
	template: JST.collectioninputTpl,
	events: {
		'click .add-button': 'addItem',
		'change input[type="checkbox"]': 'update',
		'click .delete-tag': 'deleteItem'
	},
  initialize(opts) {
	_.extend(this, opts);
		this.listenTo(this.collection, 'sort', this.render);
		this.listenTo(this.collection, 'add', this.render);
		this.listenTo(this.collection, 'remove', this.render);

		return this;
  },
	render() {
		const html = this.template({
			label: this.label,
			displayName: this.displayName,
			collection: this.collection,
			modelKey: this.modelKey,
			inputCollection: this.inputCollection
		});
		console.log('input collection', this.inputCollection);
		this.$el.html(html);

		this.$list = this.$('.collection-list');
		dragula([this.$list.get(0)]).on('drop', el => this.update());

		return this.el;
	},
	update(e) {
		this.$list.children().map((index, el) => {
			const $el = $(el);
			const $input = $el.children('input');
			const model = this.collection.get($el.data('modelid'));
			model.set({ IsDisplay: $input.is(':checked'), DisplayOrder: index })
		});

		this.collection.sort()

		return this.collection;
	},
	addItem(e) {
		e.preventDefault()
		e.stopPropagation();
		const val = this.$('.collection-item-input').val();
		if (val.length <= 0) { return };
		let data = { DisplayOrder: this.collection.length };
		data[this.displayName] = this.$('.collection-item-input').val();
		this.collection.add(data);
	},
	deleteItem(e) {
		const id = $(e.target).parent().data('modelid');
		this.collection.remove(`${id}`)
	},
  getValue() {
	return this.collection.toJSON();
  }

});

export default CollectionInput;
